import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto 2.5rem;
  position: relative;
  flex-direction: column;
  text-align: center;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 0px auto;
`;

export const VideoWrapper = styled.div`
  margin: auto;
  width: 100%;
  max-width: 947px;
  height: auto;
  padding: 1.75rem 0 0;
`;

export const VideoDescription = styled.div`
  position: relative;
  width: 100%;
  max-width: 947px;
  margin: 0 auto;
  text-align: center;
  padding: 0;

  p {
    font-size: 1.25rem;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.5rem;
      line-height: 2.25rem;
    }
  }
`;

export const ProTipWrapper = styled.div`
  margin: auto;
  width: 100%;
  max-width: 975px;
`;

export const VideoHeader = styled.h2`
  margin: 3rem auto 1rem;
  width: calc(100% - 40px);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 5rem auto 1rem;
  }
`;
